module.exports = __webpack_public_path__ + "img/digest.8f6123a0.svg";